import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  inject,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-public-layout',
  templateUrl: './public-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrls: ['./public-layout.component.css'],
  styles: [
    `
      router-outlet {
        display: contents;
      }
    `,
  ],
  standalone: false,
})
export class PublicLayoutComponent implements OnInit, OnDestroy {
  copyrightYear: number = new Date().getFullYear();

  showBanner: boolean = false;

  siteUrl: string = environment.siteUrl;

  private hideSub: Subscription | null = null;

  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    const shown = sessionStorage.getItem('domainBannerShown');

    if (shown !== null) {
      this.showBanner = false;
      this.cdr.markForCheck();
      return;
    }

    sessionStorage.setItem('domainBannerShown', '1');
    this.showBanner = true;
    this.cdr.markForCheck();

    // Auto-hide after 20s
    this.hideSub = timer(20_000).subscribe(() => {
      this.showBanner = false;
      this.cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this.hideSub?.unsubscribe();
  }
}
